import { DonorApplicationSchemaType, donorApplicationSchema } from './schema';

export const defaultFormValues: Partial<DonorApplicationSchemaType> =
  Object.keys(donorApplicationSchema.fields).reduce(
    (defaultValues, fieldName) => {
      return { ...defaultValues, [fieldName]: undefined };
    },
    {} as Partial<DonorApplicationSchemaType>
  );
